import { CloseRounded } from '@mui/icons-material';
import { Grid, Stack } from '@mui/material';
import React from 'react';

import { FormBuilderConditionProps } from './FormBuilderCondition.props';
import { StyledGrid } from './FormBuilderCondition.styles';
import { 
  FORM_BUILDER_CONDITION_OPTIONS, 
  FORM_BUILDER_COMPARE_OPTIONS, 
  FORM_BUILDER_JOIN_OPTIONS 
} from '../../../constants/form-builder';
import { getSubConditionalConditions } from '../../../utils/interactions';
import { Button, ButtonVariantProps } from '../../atoms/Button';
import { SelectMenu } from '../../atoms/SelectMenu';
import { TextField } from '../../atoms/TextField';

export const FormBuilderCondition: React.FC<FormBuilderConditionProps> = ({
  value,
  onChange,
  onRemove,
  isSubConditional,
  subConditionalConditions
}) => {
  return (
    <StyledGrid container spacing={{ xs: 2 }} pl={2} pt={2}>
      <Grid size={{ xs: 4 }}>
        <SelectMenu
          label="Condition" 
          id={`condition-select-menu-${value.id}`}
          items={getSubConditionalConditions(FORM_BUILDER_CONDITION_OPTIONS, subConditionalConditions)} 
          selectedValue={value.conditionOption}
          onChange={(val) => onChange({ ...value, conditionOption: val })}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <SelectMenu
          label="Compare Option" 
          id={`compare-option-select-menu-${value.id}`}
          items={FORM_BUILDER_COMPARE_OPTIONS} 
          selectedValue={value.compareOption}
          onChange={(val) => onChange({ ...value, compareOption: val })}
        />
      </Grid>
      <Grid size={{ xs: 5 }}>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" marginRight={1}>
          <TextField
            label="Value"
            value={value.value}
            onChange={(val) => onChange({ ...value, value: val })}
          />
          <Button
            variant={ButtonVariantProps.Icon}
            onClick={() => onRemove(value.id)}
          >
            <CloseRounded fontSize="small" color="error" />
          </Button>
        </Stack>
      </Grid>
      <Grid paddingBottom={2} size={{ xs: 2 }}>
        <SelectMenu
          label="Join Option" 
          id={`join-option-select-menu-${value.id}`}
          items={FORM_BUILDER_JOIN_OPTIONS} 
          selectedValue={value.joinOption}
          onChange={(val) => onChange({ ...value, joinOption: val })}
          disabled={isSubConditional}
        />
      </Grid>
      <Grid paddingBottom={2} size={{ xs: 10 }}></Grid>
    </StyledGrid>
  );
};
